<template>
  <div>
    <v-layout row wrap align-center justify-center class="mt-3">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
          <v-card
            class="text-xs-center ma-3"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
          >
            <v-card-title>
            <v-layout row wrap align-center justify-center class="mt-2"> 
              <span class="headline font-weight-bold">Adding High Fidelity Wireframes, if we have one handy:</span> 

              <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify mt-3"
                outline>
                Tip: For the prefered solution concept, a wireframe can be developed using a service such as AdobeXD or Marvel App. The purpose of this is to have the End user(s) interact with it, with the goal of eventually collecting feedback from them. In this section, please add the High Fidelity wireframe of the product concept, which will include details such as colors and graphics and will be representative of the final product that will be shipped to the customer.
                
              </v-alert>
              <v-btn flat small :href="linktolfwireframe" target="_blank" class="mx-2 font-weight-light" align-center justify-center>Learn more about Wireframes</v-btn> 
              </v-layout>
            </v-card-title>
            <v-card-text>
              <v-form class="px-3" ref="form">
                <!-- <span v-for="(customerproblemdetail, index) in customerproblemdetails" :key="index"> -->
                  <!-- <v-layout row wrap>  -->

                 <v-textarea
                  outline   
                  class="height-issue-fix"
                  :height="70"
                  :rules="textInputRules"
                  :label="linktowireframeLabel"
                  v-model="linktohfwireframe"
                  
                >
                 </v-textarea> 

                 


 

<!-- 
                <v-textarea outline 
                :label="metricevangelismLabelText" 
                v-model="metrictitle" :hint="metricevangelismHintText" 
                :rules="textInputRules"></v-textarea>
                 -->

                <v-spacer></v-spacer>
                <v-btn flat @click="$router.go(-1)" class="mx-4 mt-3">Head back</v-btn>
               <!-- <v-btn flat @click="submit" color="primary" class="mx-2 mt-3" :loading="loading">Head to User Quotes</v-btn> -->
                 <v-btn to="/bcprocessmodelforbufstep3" flat color="primary" class="mx-2 mt-3" :loading="loading"><!--Add link --> Complete Step 2</v-btn>                  
              </v-form>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
  name: "problemstudy",
  components: {},
  data() {
    return { 
      linktohfwireframe: 'https://marvelapp.com/1d4dj00g',  
      doWe: false,
      linktowireframeLabel:'Please enter the link to the High Fidelity wireframe below',
        //metrictitle: 'Potential customer conversions per month',
      metrictitle: '(Potential) Customer conversions per month',
      metricevangelismLabelText: 'Provide one metric to measure evangelism, based on the HF wireframe.',
      metricevangelismHintText: 'Provide one metric which will help measure the impact of evangelists sharing this wireframe, when they work to spread the word about the solution and atttract more users to try the solution concept. This can be beneficial to the solution concept since more users will know about it and if they try it out, will be able to provide feedback to improve the product.',
      textInputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      selectInputRules: [
        v => !!v || 'This field is required'
      ],
      loading: false
    }
  },
  methods: {
    submit(){
 if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            const linktowf = {
                linktohfwireframe: this.linktohfwireframe
            }
 

            db.collection('projects').doc(this.getProjectID()).update(linktowf).then(() => {
                    //console.log("added to db!", docRef.id)
                    this.loading = false;
                    this.dialog = false;
                    this.$router.push('dumaddquotes')
                    ///this.$emit('firstprefdetailsconfirmed')
                });


           const metric = {
                metrictitle: this.metrictitle,
                metriccategory: 'Evangelism'
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('metrics').add(metric).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projectadded')
       });


            //Yx3r6dHUeFFdGvY6Acvy
 

             }

    },
    getProjectID(){
      return gvars.PROJECTID;
    }
    
  },
  computed: {
    
  }
};
</script>

<style>
.height-issue-fix > div > .v-input__slot {
    min-height: 100% !important;
    max-height: 100%;
    margin-bottom: 0.2em;
  }

  .height-issue-fix fieldset {
    top: 0 !important;
    height: inherit;
  }
  
  .height-issue-fix fieldset legend {
    display:none;
  }
  
  .height-issue-fix .v-text-field__slot {
    height: inherit;
  }
  
  .height-issue-fix .v-input__append-inner {
    height: inherit;
    align-items: center;
    align-self: unset !important;
  }
</style>
